import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { IRegistrationLoginRequest, IRegistrationLoginSuccess } from '../models/registration-login.model';

//#region  Register first time user
export const loadRegisterRequest = createAction('[Register] Load Register Request', props<{ request: IRegistrationLoginRequest }>());

export const loadRegisterSuccess = createAction('[Register] Load Register Success', props<{ response: IRegistrationLoginSuccess }>());

export const loadRegisterFailure = createAction('[Register] Load Register Failure', props<{ error: IGenericError<ErrorResponse> }>());

export const clearRegisterFailure = createAction('[Register] Clear Register Failure');
export const clearRegisterSuccess = createAction('[Register] Clear Register Success');
//#endregion
